var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid-component"}},[_c('div',{staticClass:"__image_container",style:(_vm.styles)},[_vm._t("default"),_vm._v(" "),(_vm.count > 0)?_c('div',{staticClass:"__image_body __quarter __image_count",on:{"click":function($event){_vm.passData()}}},[_c('p',[_vm._v(_vm._s(_vm.image_excess))])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-379b9a33","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-photo-grid/components/PhotoGridComponent.vue
// module id = MY3S
// module chunks = 0